/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type SbRespCollectionsModules_itemSearch$ref = any;
type SbRespCollectionsModules_shippingFilters$ref = any;
type SbRespCollectionsModules_user$ref = any;
type SbRespCollectionsModules_viewer$ref = any;
type SbSharedHead_itemSearch$ref = any;
type SbSharedRefetchContainer_itemSearch$ref = any;
type SbSharedRefetchContainer_regionalInfo$ref = any;
type SbSharedRefetchContainer_shippingFilters$ref = any;
type SbSharedRefetchContainer_viewer$ref = any;
type SbSharedTrackingContainer_itemSearch$ref = any;
type SbSharedTrackingContainer_user$ref = any;
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type SbRespCollectionsLayoutRefetchQueryVariables = {
    readonly userId?: string | null;
    readonly fetchUser: boolean;
    readonly fetchSb: boolean;
    readonly skipUser?: boolean | null;
    readonly isTrade: boolean;
    readonly uriRef?: string | null;
    readonly first: number;
    readonly page: number;
    readonly localeOrigin?: string | null;
    readonly showSeller: boolean;
    readonly followSearchPages?: ReadonlyArray<string | null> | null;
    readonly followSearchTypes?: ReadonlyArray<types | null> | null;
    readonly contentModuleId?: string | null;
    readonly eligibleAbTest?: string | null;
    readonly hasPersonalizedFilter: boolean;
    readonly userZipCode?: string | null;
    readonly disableForceFacet?: boolean | null;
};
export type SbRespCollectionsLayoutRefetchQueryResponse = {
    readonly viewer: {
        readonly itemSearch?: {
            readonly " $fragmentRefs": SbSharedRefetchContainer_itemSearch$ref & SbRespCollectionsModules_itemSearch$ref & SbSharedHead_itemSearch$ref & SbSharedTrackingContainer_itemSearch$ref;
        } | null;
        readonly user?: {
            readonly " $fragmentRefs": SbSharedTrackingContainer_user$ref & SbRespCollectionsModules_user$ref;
        } | null;
        readonly regionalInfo?: ReadonlyArray<{
            readonly " $fragmentRefs": SbSharedRefetchContainer_regionalInfo$ref;
        } | null> | null;
        readonly shippingFilters?: ReadonlyArray<{
            readonly " $fragmentRefs": SbSharedRefetchContainer_shippingFilters$ref & SbRespCollectionsModules_shippingFilters$ref;
        } | null> | null;
        readonly " $fragmentRefs": SbRespCollectionsModules_viewer$ref & SbSharedRefetchContainer_viewer$ref;
    } | null;
};
export type SbRespCollectionsLayoutRefetchQuery = {
    readonly response: SbRespCollectionsLayoutRefetchQueryResponse;
    readonly variables: SbRespCollectionsLayoutRefetchQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "fetchUser",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "fetchSb",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "skipUser",
            "type": "Boolean",
            "defaultValue": true
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "isTrade",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "uriRef",
            "type": "String",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "first",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "page",
            "type": "Int!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "localeOrigin",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "showSeller",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "followSearchPages",
            "type": "[String]",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "followSearchTypes",
            "type": "[types]",
            "defaultValue": [
                "SEARCH"
            ]
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "contentModuleId",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "eligibleAbTest",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "hasPersonalizedFilter",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userZipCode",
            "type": "String",
            "defaultValue": "0"
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "disableForceFacet",
            "type": "Boolean",
            "defaultValue": true
        } as any)
    ], v1 = ({
        "kind": "Variable",
        "name": "uriRef",
        "variableName": "uriRef"
    } as any), v2 = [
        ({
            "kind": "Variable",
            "name": "disableForceFacet",
            "variableName": "disableForceFacet"
        } as any),
        ({
            "kind": "Variable",
            "name": "eligibleAbTest",
            "variableName": "eligibleAbTest"
        } as any),
        ({
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        } as any),
        ({
            "kind": "Variable",
            "name": "localeOrigin",
            "variableName": "localeOrigin"
        } as any),
        ({
            "kind": "Variable",
            "name": "page",
            "variableName": "page"
        } as any),
        (v1 /*: any*/)
    ], v3 = [
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ], v4 = ({
        "kind": "Variable",
        "name": "zipCode",
        "variableName": "userZipCode"
    } as any), v5 = [
        (v4 /*: any*/)
    ], v6 = [
        (v1 /*: any*/),
        (v4 /*: any*/)
    ], v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v8 = [
        ({
            "kind": "Literal",
            "name": "featureName",
            "value": "NON_MVP_SEARCH_BROWSE"
        } as any)
    ], v9 = ({
        "kind": "Literal",
        "name": "first",
        "value": 1
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "count",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "displayName",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "urlLabel",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "iconUri",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "description",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "linkReference",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hexCode",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "localizedFilterName",
        "args": null,
        "storageKey": null
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "currency",
        "args": null,
        "storageKey": null
    } as any), v22 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "key",
        "args": null,
        "storageKey": null
    } as any), v23 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalCount",
        "args": null,
        "storageKey": null
    } as any), v24 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v25 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "moduleType",
        "args": null,
        "storageKey": null
    } as any), v26 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "photo",
        "args": null,
        "storageKey": null
    } as any), v27 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "subtitle",
        "args": null,
        "storageKey": null
    } as any), v28 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "link",
        "args": null,
        "storageKey": null
    } as any), v29 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "linkText",
        "args": null,
        "storageKey": null
    } as any), v30 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v31 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "categoryPath",
        "args": null,
        "storageKey": null
    } as any), v32 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "browseUrl",
        "args": null,
        "storageKey": null
    } as any), v33 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "categoryCode",
        "args": null,
        "storageKey": null
    } as any), v34 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "contemporaryTrackingString",
        "args": null,
        "storageKey": null
    } as any), v35 = [
        (v30 /*: any*/),
        (v7 /*: any*/)
    ], v36 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "seller",
        "storageKey": null,
        "args": null,
        "concreteType": "Seller",
        "plural": false,
        "selections": (v35 /*: any*/)
    } as any), v37 = [
        ({
            "kind": "Variable",
            "name": "isTrade",
            "variableName": "isTrade"
        } as any),
        ({
            "kind": "Literal",
            "name": "page",
            "value": "searchAndBrowse"
        } as any)
    ], v38 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "amount",
        "args": null,
        "storageKey": null
    } as any), v39 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "convertedAmountList",
        "storageKey": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "plural": true,
        "selections": [
            (v38 /*: any*/),
            (v21 /*: any*/)
        ]
    } as any), v40 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
    } as any), v41 = [
        ({
            "kind": "Literal",
            "name": "formatType",
            "value": "MOBILE"
        } as any)
    ], v42 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "paragraphs",
        "storageKey": null,
        "args": null,
        "concreteType": "QuickViewParagraph",
        "plural": true,
        "selections": [
            (v22 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "text",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": "mobileText",
                "name": "text",
                "args": (v41 /*: any*/),
                "storageKey": "text(formatType:\"MOBILE\")"
            }
        ]
    } as any), v43 = ({
        "kind": "ScalarField",
        "alias": "mobileTitle",
        "name": "title",
        "args": (v41 /*: any*/),
        "storageKey": "title(formatType:\"MOBILE\")"
    } as any), v44 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isCustomizable",
        "args": null,
        "storageKey": null
    } as any), v45 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isMultiSku",
        "args": null,
        "storageKey": null
    } as any), v46 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "localizedPdpUrl",
        "args": null,
        "storageKey": null
    } as any), v47 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "vertical",
        "args": null,
        "storageKey": null
    } as any), v48 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "displayPrice",
        "storageKey": null,
        "args": (v37 /*: any*/),
        "concreteType": "ItemDisplayPriceType",
        "plural": true,
        "selections": [
            (v39 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "quantityDisplay",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "percentageOff",
                "args": null,
                "storageKey": null
            },
            (v40 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "showPriceLabel",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "showPriceVariability",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v49 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "lowestShipmentQuote",
        "storageKey": null,
        "args": null,
        "concreteType": "ShipmentQuote",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "complimentaryShipping",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "totalAmount",
                "storageKey": null,
                "args": null,
                "concreteType": "FinancialAmount",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "convertedAmountList",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ConvertedAmountList",
                        "plural": true,
                        "selections": [
                            (v21 /*: any*/),
                            (v38 /*: any*/)
                        ]
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "serviceMethod",
                "storageKey": null,
                "args": null,
                "concreteType": "ShipmentServiceMethod",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "isWhiteGlove",
                        "args": null,
                        "storageKey": null
                    },
                    (v7 /*: any*/)
                ]
            },
            (v7 /*: any*/)
        ]
    } as any), v50 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "classification",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemClassification",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "creationDate",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v51 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "creators",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemCreator",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "attribution",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "creator",
                "storageKey": null,
                "args": null,
                "concreteType": "Creator",
                "plural": false,
                "selections": [
                    (v11 /*: any*/),
                    (v7 /*: any*/)
                ]
            },
            (v7 /*: any*/)
        ]
    } as any), v52 = [
        ({
            "kind": "Literal",
            "name": "limit",
            "value": 1
        } as any)
    ], v53 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "placeholder",
        "args": null,
        "storageKey": null
    } as any), v54 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "masterOrZoomPath",
        "args": null,
        "storageKey": null
    } as any), v55 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "versions",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemPhotoVersion",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "webPath",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v56 = ({
        "kind": "LinkedField",
        "alias": "productPhotos",
        "name": "photos",
        "storageKey": "photos(limit:1)",
        "args": (v52 /*: any*/),
        "concreteType": "ItemPhoto",
        "plural": true,
        "selections": [
            (v53 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "smallPath",
                "args": null,
                "storageKey": null
            },
            (v54 /*: any*/),
            (v55 /*: any*/),
            (v7 /*: any*/)
        ]
    } as any), v57 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "value",
        "args": null,
        "storageKey": null
    } as any), v58 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "measurement",
        "storageKey": null,
        "args": null,
        "concreteType": "ItemMeasurement",
        "plural": false,
        "selections": [
            {
                "kind": "LinkedField",
                "alias": "dimensions",
                "name": "display",
                "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\"],separator:\" \")",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "addLabel",
                        "value": true
                    },
                    {
                        "kind": "Literal",
                        "name": "fields",
                        "value": [
                            "height",
                            "width",
                            "depth",
                            "diameter"
                        ]
                    },
                    {
                        "kind": "Literal",
                        "name": "separator",
                        "value": " "
                    }
                ],
                "concreteType": "ItemDisplayMeasurementType",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "unit",
                        "args": null,
                        "storageKey": null
                    },
                    (v57 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "size",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemSize",
                "plural": false,
                "selections": [
                    (v57 /*: any*/)
                ]
            }
        ]
    } as any), v59 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "sellerProfile",
        "storageKey": null,
        "args": null,
        "concreteType": "SellerProfile",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "company",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v60 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "photos",
        "storageKey": "photos(limit:1)",
        "args": (v52 /*: any*/),
        "concreteType": "ItemPhoto",
        "plural": true,
        "selections": [
            (v53 /*: any*/),
            (v7 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "largePath",
                "args": null,
                "storageKey": null
            },
            (v54 /*: any*/)
        ]
    } as any), v61 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "daysRelativeToExpiration",
        "args": [
            {
                "kind": "Literal",
                "name": "truncate",
                "value": false
            }
        ],
        "storageKey": "daysRelativeToExpiration(truncate:false)"
    } as any), v62 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "benefit",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "SbRespCollectionsLayoutRefetchQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "Condition",
                            "passingValue": false,
                            "condition": "fetchSb",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "SbRespCollectionsModules_viewer",
                                    "args": null
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "SbSharedRefetchContainer_viewer",
                            "args": null
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchSb",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "itemSearch",
                                    "storageKey": null,
                                    "args": (v2 /*: any*/),
                                    "concreteType": "ItemSearchQueryConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "SbSharedRefetchContainer_itemSearch",
                                            "args": null
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "SbRespCollectionsModules_itemSearch",
                                            "args": null
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "SbSharedHead_itemSearch",
                                            "args": null
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "SbSharedTrackingContainer_itemSearch",
                                            "args": null
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": false,
                            "condition": "skipUser",
                            "selections": [
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "fetchUser",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "user",
                                            "storageKey": null,
                                            "args": (v3 /*: any*/),
                                            "concreteType": "User",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "SbSharedTrackingContainer_user",
                                                    "args": null
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "SbRespCollectionsModules_user",
                                                    "args": null
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasPersonalizedFilter",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "regionalInfo",
                                    "storageKey": null,
                                    "args": (v5 /*: any*/),
                                    "concreteType": "RegionalInfo",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "SbSharedRefetchContainer_regionalInfo",
                                            "args": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shippingFilters",
                                    "storageKey": null,
                                    "args": (v6 /*: any*/),
                                    "concreteType": "ShippingFilterType",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "SbSharedRefetchContainer_shippingFilters",
                                            "args": null
                                        },
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "SbRespCollectionsModules_shippingFilters",
                                            "args": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "SbRespCollectionsLayoutRefetchQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": "enableSearchLandingPage",
                            "name": "isEnabled",
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "key",
                                    "value": "enableSearchLandingPage"
                                }
                            ],
                            "storageKey": "isEnabled(key:\"enableSearchLandingPage\")"
                        },
                        (v7 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": false,
                            "condition": "fetchSb",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": "isCollectionsModuleEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "featureName",
                                            "value": "BROWSE_COLLECTIONS_MODULES"
                                        }
                                    ],
                                    "storageKey": "isEnabledByLocale(featureName:\"BROWSE_COLLECTIONS_MODULES\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isBillboardAdEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": (v8 /*: any*/),
                                    "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isThinPageEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": (v8 /*: any*/),
                                    "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isMoreWaysToBrowseEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": (v8 /*: any*/),
                                    "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isShopByRoomEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "featureName",
                                            "value": "SHOP_BY_ROOM"
                                        }
                                    ],
                                    "storageKey": "isEnabledByLocale(featureName:\"SHOP_BY_ROOM\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isSbRespFollowSearchEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": (v8 /*: any*/),
                                    "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "disableFollowSearchStickyBanner",
                                    "name": "isEnabled",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "disableFollowSearchStickyBanner"
                                        }
                                    ],
                                    "storageKey": "isEnabled(key:\"disableFollowSearchStickyBanner\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isContentModuleEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "featureName",
                                            "value": "BROWSE_CONTENT_MODULES"
                                        }
                                    ],
                                    "storageKey": "isEnabledByLocale(featureName:\"BROWSE_CONTENT_MODULES\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isSkyscraperAdEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": (v8 /*: any*/),
                                    "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isSbSharedRefineMenuSearchWithinEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": (v8 /*: any*/),
                                    "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isMatchedSetsEnabled",
                                    "name": "isEnabled",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "key",
                                            "value": "enableMatchedSetsFacet"
                                        }
                                    ],
                                    "storageKey": "isEnabled(key:\"enableMatchedSetsFacet\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isSearchWithinFilterEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "featureName",
                                            "value": "REFINE_MENU_SEARCH"
                                        }
                                    ],
                                    "storageKey": "isEnabledByLocale(featureName:\"REFINE_MENU_SEARCH\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isDeliveryOptionsDisabled",
                                    "name": "isEnabledByLocale",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "featureName",
                                            "value": "DISABLE_SB_DELIVERY_OPTION_FILTERS"
                                        }
                                    ],
                                    "storageKey": "isEnabledByLocale(featureName:\"DISABLE_SB_DELIVERY_OPTION_FILTERS\")"
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "locations",
                                    "name": "itemFacetSearch",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "facetName",
                                            "value": "location"
                                        },
                                        (v9 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "page",
                                            "value": 1
                                        },
                                        (v1 /*: any*/),
                                        (v4 /*: any*/)
                                    ],
                                    "concreteType": "ItemFacetsQueryConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ItemFacetsQueryEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "FilterValueType",
                                                    "plural": false,
                                                    "selections": [
                                                        (v10 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v12 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isSbSharedRefineMenuDisplayPrefsSelectEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": (v8 /*: any*/),
                                    "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isSeoQuicklookEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "featureName",
                                            "value": "SEO_QUICKLOOK"
                                        }
                                    ],
                                    "storageKey": "isEnabledByLocale(featureName:\"SEO_QUICKLOOK\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isTileAdEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": (v8 /*: any*/),
                                    "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isFavoritesEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": (v8 /*: any*/),
                                    "storageKey": "isEnabledByLocale(featureName:\"NON_MVP_SEARCH_BROWSE\")"
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": "isVisuallySimilarEnabled",
                                    "name": "isEnabledByLocale",
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "featureName",
                                            "value": "VISUALLY_SIMILAR"
                                        }
                                    ],
                                    "storageKey": "isEnabledByLocale(featureName:\"VISUALLY_SIMILAR\")"
                                },
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "isTrade",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "tradeProgramsQuery",
                                            "storageKey": "tradeProgramsQuery(programCodes:[\"BRONZE\"])",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "programCodes",
                                                    "value": [
                                                        "BRONZE"
                                                    ]
                                                }
                                            ],
                                            "concreteType": "LoyaltyProgram",
                                            "plural": true,
                                            "selections": [
                                                (v13 /*: any*/),
                                                (v7 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": "isSbTradeFreeShippingTestDisabled",
                                            "name": "isEnabled",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "key",
                                                    "value": "disableSbTradeFreeShippingTest"
                                                }
                                            ],
                                            "storageKey": "isEnabled(key:\"disableSbTradeFreeShippingTest\")"
                                        },
                                        {
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "condition": "isTrade",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": "parentPrograms",
                                                    "name": "tradeProgramsQuery",
                                                    "storageKey": "tradeProgramsQuery(programCodes:[\"MEMBER\",\"BRONZE\",\"SILVER\",\"GOLD\",\"PLATINUM\"])",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "programCodes",
                                                            "value": [
                                                                "MEMBER",
                                                                "BRONZE",
                                                                "SILVER",
                                                                "GOLD",
                                                                "PLATINUM"
                                                            ]
                                                        }
                                                    ],
                                                    "concreteType": "LoyaltyProgram",
                                                    "plural": true,
                                                    "selections": [
                                                        (v14 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v13 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "maxPoints",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "minPoints",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v7 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchSb",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "itemSearch",
                                    "storageKey": null,
                                    "args": (v2 /*: any*/),
                                    "concreteType": "ItemSearchQueryConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "pageType",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "vanityUriRef",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "displayUriRef",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "searchCorrections",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SearchCorrectionsType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "semanticSearchTerm",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "suggestions",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "SearchCorrectionSuggestionsValues",
                                                    "plural": true,
                                                    "selections": [
                                                        (v15 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "uri",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "totalResults",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "canFollowSearch",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "meta",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "MetaData",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "header",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "canonical",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "prev",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "disableIndexing",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v16 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "next",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "microdata",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "appliedFilters",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SearchBrowseParsedParam",
                                            "plural": true,
                                            "selections": [
                                                (v15 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "values",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "SearchBrowseParsedParamValue",
                                                    "plural": true,
                                                    "selections": [
                                                        (v12 /*: any*/),
                                                        (v18 /*: any*/),
                                                        (v11 /*: any*/),
                                                        (v19 /*: any*/),
                                                        (v10 /*: any*/),
                                                        (v14 /*: any*/)
                                                    ]
                                                },
                                                (v20 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "canBeDismissed",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "clearAllLinkReference",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "breadcrumbs",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SearchBrowseBreadcrumbs",
                                            "plural": true,
                                            "selections": [
                                                (v11 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "path",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "topCategoryL1",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "displayMaxNumberOfPages",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "clearAppliedFiltersLinkReference",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "filters",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SearchBrowseFilter",
                                            "plural": true,
                                            "selections": [
                                                (v15 /*: any*/),
                                                (v20 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "values",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "SearchBrowseFilterValue",
                                                    "plural": true,
                                                    "selections": [
                                                        (v11 /*: any*/),
                                                        (v12 /*: any*/),
                                                        (v18 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "linkable",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v21 /*: any*/),
                                                        (v10 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "stats",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "stats",
                                                            "plural": true,
                                                            "selections": [
                                                                (v22 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "values",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                }
                                                            ]
                                                        },
                                                        (v14 /*: any*/),
                                                        (v19 /*: any*/)
                                                    ]
                                                },
                                                (v23 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "isAttributePage",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "browseContentModule",
                                            "storageKey": null,
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "contentModuleId",
                                                    "variableName": "contentModuleId"
                                                }
                                            ],
                                            "concreteType": null,
                                            "plural": false,
                                            "selections": [
                                                (v24 /*: any*/),
                                                (v25 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "type": "ContentModuleRegular",
                                                    "selections": [
                                                        (v17 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v26 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "type": "ContentModuleBanner",
                                                    "selections": [
                                                        (v26 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v27 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v28 /*: any*/),
                                                        (v29 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "type": "ContentModulePromo",
                                                    "selections": [
                                                        (v26 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "pillText",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "headline",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "subtext",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        (v28 /*: any*/),
                                                        (v29 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "sort",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SortType",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "options",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "SearchBrowseSortAvailableOptions",
                                                    "plural": true,
                                                    "selections": [
                                                        (v12 /*: any*/),
                                                        (v11 /*: any*/)
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "currentOption",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "SearchBrowseSortCurrentOption",
                                                    "plural": false,
                                                    "selections": [
                                                        (v12 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "searchTerm",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "ItemSearchQueryEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "ItemSearchResult",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "item",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Item",
                                                            "plural": false,
                                                            "selections": [
                                                                (v30 /*: any*/),
                                                                (v16 /*: any*/),
                                                                (v31 /*: any*/),
                                                                (v32 /*: any*/),
                                                                (v33 /*: any*/),
                                                                (v34 /*: any*/),
                                                                (v36 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": "displayPriceTracking",
                                                                    "name": "displayPrice",
                                                                    "storageKey": null,
                                                                    "args": (v37 /*: any*/),
                                                                    "concreteType": "ItemDisplayPriceType",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v39 /*: any*/),
                                                                        (v40 /*: any*/)
                                                                    ]
                                                                },
                                                                (v7 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "quickViewDisplay",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "QuickViewDisplayType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v42 /*: any*/),
                                                                        (v16 /*: any*/),
                                                                        (v43 /*: any*/)
                                                                    ]
                                                                },
                                                                (v44 /*: any*/),
                                                                (v45 /*: any*/),
                                                                (v46 /*: any*/),
                                                                (v47 /*: any*/),
                                                                (v48 /*: any*/),
                                                                (v49 /*: any*/),
                                                                (v50 /*: any*/),
                                                                (v51 /*: any*/),
                                                                (v56 /*: any*/),
                                                                (v58 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "displayInfo",
                                                                    "storageKey": null,
                                                                    "args": (v37 /*: any*/),
                                                                    "concreteType": "ItemDisplayInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "ctas",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "CTADisplay",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "showMakeOffer",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "photos",
                                                                    "storageKey": "photos(limit:1)",
                                                                    "args": (v52 /*: any*/),
                                                                    "concreteType": "ItemPhoto",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        (v55 /*: any*/),
                                                                        (v7 /*: any*/)
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "condition": "showSeller",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "seller",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "Seller",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v59 /*: any*/)
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "condition": "isTrade",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "lowestShipmentQuote",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "ShipmentQuote",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "isFreeToBuyer",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        (v7 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": "relatedItems",
                                            "name": "thinBrowseRelatedItems",
                                            "storageKey": "thinBrowseRelatedItems(first:12,seller:\"INCLUDE\")",
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "first",
                                                    "value": 12
                                                },
                                                {
                                                    "kind": "Literal",
                                                    "name": "seller",
                                                    "value": "INCLUDE"
                                                }
                                            ],
                                            "concreteType": "itemSearchMoreLikeThisConnection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "edges",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "itemSearchMoreLikeThisEdge",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "node",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Item",
                                                            "plural": false,
                                                            "selections": [
                                                                (v44 /*: any*/),
                                                                (v45 /*: any*/),
                                                                (v30 /*: any*/),
                                                                (v46 /*: any*/),
                                                                (v16 /*: any*/),
                                                                (v47 /*: any*/),
                                                                (v48 /*: any*/),
                                                                (v49 /*: any*/),
                                                                (v50 /*: any*/),
                                                                (v51 /*: any*/),
                                                                (v56 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "quickViewDisplay",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "QuickViewDisplayType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v16 /*: any*/),
                                                                        (v43 /*: any*/),
                                                                        (v42 /*: any*/)
                                                                    ]
                                                                },
                                                                (v58 /*: any*/),
                                                                (v32 /*: any*/),
                                                                (v33 /*: any*/),
                                                                (v7 /*: any*/),
                                                                {
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "condition": "showSeller",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "seller",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "Seller",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v30 /*: any*/),
                                                                                (v59 /*: any*/),
                                                                                (v7 /*: any*/)
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "internalBuyLinks",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "InternalBuyLinkType",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "anchorText",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "url",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                (v7 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "collectionsModules",
                                            "storageKey": null,
                                            "args": [
                                                {
                                                    "kind": "Variable",
                                                    "name": "previewId",
                                                    "variableName": "contentModuleId"
                                                }
                                            ],
                                            "concreteType": null,
                                            "plural": true,
                                            "selections": [
                                                (v24 /*: any*/),
                                                (v25 /*: any*/),
                                                (v7 /*: any*/),
                                                {
                                                    "kind": "InlineFragment",
                                                    "type": "CollectionsModulesHero",
                                                    "selections": [
                                                        (v26 /*: any*/),
                                                        (v16 /*: any*/),
                                                        (v27 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v28 /*: any*/),
                                                        (v29 /*: any*/),
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "variation",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "type": "CollectionsModulesPhotoCarousel",
                                                    "selections": [
                                                        (v16 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "itemsConnection",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "CmsItemsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "edges",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "CmsItemsEdge",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "cmsData",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "CmsData",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v16 /*: any*/),
                                                                                (v17 /*: any*/)
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "node",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "Item",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v60 /*: any*/),
                                                                                (v46 /*: any*/),
                                                                                (v51 /*: any*/),
                                                                                (v7 /*: any*/),
                                                                                (v30 /*: any*/)
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "type": "CollectionsModulesMainContent",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "gridType",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "type": "CollectionsModulesCreatorSpotlight",
                                                    "selections": [
                                                        (v16 /*: any*/),
                                                        (v26 /*: any*/),
                                                        (v17 /*: any*/),
                                                        (v28 /*: any*/),
                                                        (v29 /*: any*/),
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "itemsConnection",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "CmsItemsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "edges",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "CmsItemsEdge",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "cmsData",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "CmsData",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v16 /*: any*/)
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "node",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "Item",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v46 /*: any*/),
                                                                                (v60 /*: any*/),
                                                                                (v48 /*: any*/),
                                                                                (v7 /*: any*/),
                                                                                (v30 /*: any*/)
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "languageAnnotations",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "LanguageAnnotations",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "href",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "hrefLang",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "available",
                                                    "args": null,
                                                    "storageKey": null
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "categoryTiles",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "SearchBrowseCategoryTiles",
                                            "plural": true,
                                            "selections": [
                                                (v11 /*: any*/)
                                            ]
                                        },
                                        {
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "condition": "isTrade",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "facets",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "SearchBrowseFacets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "location",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "FacetValueType",
                                                            "plural": true,
                                                            "selections": [
                                                                (v15 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "label",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v7 /*: any*/)
                                                            ]
                                                        },
                                                        (v7 /*: any*/)
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": false,
                            "condition": "skipUser",
                            "selections": [
                                {
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "condition": "fetchUser",
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "user",
                                            "storageKey": null,
                                            "args": (v3 /*: any*/),
                                            "concreteType": "User",
                                            "plural": false,
                                            "selections": [
                                                (v30 /*: any*/),
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "isVerifiedTrade",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": null,
                                                    "name": "canShowSellerName",
                                                    "args": null,
                                                    "storageKey": null
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "favorites",
                                                    "storageKey": null,
                                                    "args": [
                                                        (v9 /*: any*/),
                                                        {
                                                            "kind": "Variable",
                                                            "name": "pages",
                                                            "variableName": "followSearchPages"
                                                        },
                                                        {
                                                            "kind": "Variable",
                                                            "name": "types",
                                                            "variableName": "followSearchTypes"
                                                        }
                                                    ],
                                                    "concreteType": "favoritesConnection",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "edges",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "favoritesEdge",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "node",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "Favorite",
                                                                    "plural": false,
                                                                    "selections": (v35 /*: any*/)
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "recentHistoryList",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "RecentHistoryItem",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "eventDate",
                                                            "args": null,
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "item",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "Item",
                                                            "plural": false,
                                                            "selections": [
                                                                (v34 /*: any*/),
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "firstPhotoWebPath",
                                                                    "args": [
                                                                        {
                                                                            "kind": "Literal",
                                                                            "name": "size",
                                                                            "value": "small"
                                                                        }
                                                                    ],
                                                                    "storageKey": "firstPhotoWebPath(size:\"small\")"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "alias": null,
                                                                    "name": "pdpURL",
                                                                    "args": null,
                                                                    "storageKey": null
                                                                },
                                                                (v16 /*: any*/),
                                                                (v32 /*: any*/),
                                                                (v33 /*: any*/),
                                                                (v30 /*: any*/),
                                                                (v31 /*: any*/),
                                                                (v36 /*: any*/),
                                                                (v7 /*: any*/)
                                                            ]
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": "canShowInternalSellerName",
                                                    "name": "hasPermission",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "name",
                                                            "value": "VIEW_SELLER_NAME"
                                                        }
                                                    ],
                                                    "storageKey": "hasPermission(name:\"VIEW_SELLER_NAME\")"
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "profile",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "Profile",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "alias": null,
                                                            "name": "measurementUnit",
                                                            "args": null,
                                                            "storageKey": null
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "alias": "showStrategicPartnerFilter",
                                                    "name": "hasPermission",
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "name",
                                                            "value": "STRATEGIC_PARTNER_FILTERING"
                                                        }
                                                    ],
                                                    "storageKey": "hasPermission(name:\"STRATEGIC_PARTNER_FILTERING\")"
                                                },
                                                (v7 /*: any*/),
                                                {
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "condition": "isTrade",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "expiringPromotion",
                                                            "storageKey": "expiringPromotion(daysToExpiration:14,promoCodes:[\"TRADEWELCOME\",\"TRADESHIP\",\"RISKFREE\"])",
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "daysToExpiration",
                                                                    "value": 14
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "promoCodes",
                                                                    "value": [
                                                                        "TRADEWELCOME",
                                                                        "TRADESHIP",
                                                                        "RISKFREE"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "Promotion",
                                                            "plural": false,
                                                            "selections": [
                                                                (v61 /*: any*/),
                                                                (v14 /*: any*/),
                                                                (v7 /*: any*/)
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "tradeFirm",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "TradeFirmType",
                                                            "plural": false,
                                                            "selections": [
                                                                (v7 /*: any*/),
                                                                (v30 /*: any*/),
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "rewards",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "TradeFirmRewards",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "educationMessagingSegments",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "RewardsMessagingSegment",
                                                                            "plural": true,
                                                                            "selections": (v62 /*: any*/)
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "pointsToMaintainStatus",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "pointsMessagingSegments",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "RewardsMessagingSegment",
                                                                            "plural": true,
                                                                            "selections": (v62 /*: any*/)
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "homepageMessagingSegments",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "RewardsMessagingSegment",
                                                                            "plural": true,
                                                                            "selections": (v62 /*: any*/)
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "postCheckoutMessagingSegments",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "RewardsMessagingSegment",
                                                                            "plural": true,
                                                                            "selections": (v62 /*: any*/)
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "tpnRole",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "TradeFirmTPNRole",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v14 /*: any*/)
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "condition": "isTrade",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "loyalty",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "TradeFirmLoyaltyType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "currentYearSpend",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "FinancialAmount",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v38 /*: any*/)
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "status",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "rewards",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "TradeFirmRewards",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "currentProgram",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ParentProgram",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "alias": null,
                                                                                            "name": "programInfo",
                                                                                            "storageKey": null,
                                                                                            "args": null,
                                                                                            "concreteType": "LoyaltyProgram",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v14 /*: any*/),
                                                                                                (v11 /*: any*/),
                                                                                                (v13 /*: any*/),
                                                                                                (v7 /*: any*/)
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "alias": null,
                                                                                    "name": "nextProgram",
                                                                                    "storageKey": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ParentProgram",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "alias": null,
                                                                                            "name": "programInfo",
                                                                                            "storageKey": null,
                                                                                            "args": null,
                                                                                            "concreteType": "LoyaltyProgram",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v11 /*: any*/),
                                                                                                (v13 /*: any*/),
                                                                                                (v7 /*: any*/)
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "tradeFirmRewards",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "TradeFirmRewards",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "currentPromoSegment",
                                                                    "storageKey": null,
                                                                    "args": (v3 /*: any*/),
                                                                    "concreteType": "currentPromoSegmentType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "segmentCode",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "alias": null,
                                                                            "name": "promotion",
                                                                            "storageKey": null,
                                                                            "args": null,
                                                                            "concreteType": "Promotion",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                (v14 /*: any*/),
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "alias": null,
                                                                                    "name": "buyerExpirationDate",
                                                                                    "args": null,
                                                                                    "storageKey": null
                                                                                },
                                                                                (v7 /*: any*/)
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "expiringPromoSegment",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "expiringPromoSegmentType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "alias": null,
                                                                            "name": "expiringSegmentCode",
                                                                            "args": null,
                                                                            "storageKey": null
                                                                        },
                                                                        (v61 /*: any*/)
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasPersonalizedFilter",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "regionalInfo",
                                    "storageKey": null,
                                    "args": (v5 /*: any*/),
                                    "concreteType": "RegionalInfo",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "regionsByZipCode",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "RegionsByZipCode",
                                            "plural": true,
                                            "selections": [
                                                (v11 /*: any*/),
                                                (v12 /*: any*/)
                                            ]
                                        },
                                        (v7 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "shippingFilters",
                                    "storageKey": null,
                                    "args": (v6 /*: any*/),
                                    "concreteType": "ShippingFilterType",
                                    "plural": true,
                                    "selections": [
                                        (v23 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "SbRespCollectionsLayoutRefetchQuery",
            "id": "app-buyer-finding/234.0.0-2019-09-27T13:34:34.101Z/SbRespCollectionsLayoutRefetchQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '51d9e7d3b3e3727a5a090a8502ab615a';
export default node;
